<template>
    <div class="visual-infrastructure">
        <svg class="visual-infrastructure__svg-canvas"
             :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid slice"
        >
            <template v-for="item in infrastructure">
                <svg
                    :x="[item.left ? item.left : 0]"
                    :y="[item.top ? item.top : 0]"
                    :key=item.id
                    ref="anchor"
                ></svg>
            </template>
        </svg>

        <template v-for="item in infrastructure">
            <div
                class="visual-infrastructure__item"
                :id=item.id
                :key=item.id
                v-html="item.icon"
                :style="{ top: item.reposition.top, left: item.reposition.left}"
                ref="infrastructure"
                @mouseover="mouseOverHandler(item.id, $event)"
                @mousemove="mouseMoveHandler"
                @mouseleave="mouseLeaveHandler"
            >
            </div>
        </template>
    </div>
</template>

<style lang='scss'>
    @import "./Infrastructure.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import reposition from '../../helpers/reposition';

const observer = new Observer();

export default {
    computed: {
        ...mapGetters({
            renderSize    : 'GET_CANVAS_SIZE',
            infrastructure: 'GET_INFRASTRUCTURE',
            rotate        : 'GET_ROTATE'
        })
    },

    watch: {
        rotate() {
            this.$nextTick(() => {
                this.position();
            });
        }
    },

    mounted() {
        this.position();

        window.addEventListener('resize', this.position);
    },

    methods: {
        ...mapActions(['changePosition']),

        /**
         * Метод позиционирует инфраструктуру согласно координатам svg-якорей.
         */
        position() {
            if (this.infrastructure && this.infrastructure.length) {
                const coords = reposition(this.$refs.anchor);

                this.changePosition({
                    type: 'infrastructure',
                    coords
                });
            }
        },

        mouseOverHandler(id, event) {
            observer.publish('mouseoverTooltip', {
                id,
                event,
                elements: this.infrastructure,
                type    : 'infrastructure',
                modify  : 'visual-tooltip_theme_infrastructure'
            });
        },

        mouseMoveHandler(event) {
            observer.publish('mousemoveTooltip', event);
        },

        mouseLeaveHandler() {
            observer.publish('mouseleaveTooltip');
        }
    },

    destroyed() {
        window.removeEventListener('resize', this.position);
    }
};
</script>
